import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import { Translation } from 'react-i18next'
class OwnInfoComponent extends React.Component {
  render() {
    return <OwnInfo {...this.props} />
  }
}

const styles = (theme) => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(3),
    overflowX: 'auto',
    '&::-webkit-scrollbar': {
      width: '12px !important',
      webkitOverflowScrolling: 'auto !important'
    },

    '&::-webkit-scrollbar-track': {
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3) !important',
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important'
    },

    '&::-webkit-scrollbar-thumb': {
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important',
      background: '#41617D !important',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.5) !important'
    },

    '&::-webkit-scrollbar-thumb:window-inactive': {
      background: '#41617D !important'
    }
  },
  table: {
    minWidth: 200
  },
  tablecell: {
    fontWeight: 'normal',
    fontSize: '13px',
    color: 'black'
  }
})

const OwnInfo = ({
  userTaxInfo,
  classes,
  userType,
  selectedUser,
  due_invoices,
  lang,
  dueInvoicesSum
}) => (
  <Translation>
    {(t) => {
      return (
        <div className="panel-body">
          <div className={classes.root}>
            <Table className={classes.table}>
              <TableBody>
                <TableRow style={{ background: '#ebf9fa' }}>
                  <TableCell className={classes.tablecell}>
                    {t('dashboarInfo.vero')}
                  </TableCell>
                  <TableCell className={classes.tablecell}>
                    {userType == 2 && selectedUser.email == undefined
                      ? ''
                      : `${userTaxInfo.tax_percentage} % `}
                  </TableCell>
                </TableRow>
                <TableRow style={{ background: 'white' }}>
                  <TableCell className={classes.tablecell}>
                    {t('dashboarInfo.dueInvoices')}
                  </TableCell>
                  <TableCell className={classes.tablecell}>
                    {userType === 2 && !selectedUser.email ? (
                      ''
                    ) : lang === 'fi' ? (
                      <>{due_invoices} kpl</>
                    ) : (
                      <>{due_invoices}</>
                    )}
                  </TableCell>
                </TableRow>
                <TableRow style={{ background: '#ebf9fa' }}>
                  <TableCell className={classes.tablecell}>
                    {t('dashboarInfo.dueInvoicesSum')}
                  </TableCell>
                  <TableCell className={classes.tablecell}>
                    {userType == 2 && selectedUser.email == undefined
                      ? ''
                      : new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(dueInvoicesSum)}
                  </TableCell>
                </TableRow>
                <TableRow style={{ background: 'white' }}>
                  <TableCell className={classes.tablecell}>
                    {t('dashboarInfo.yel')}
                  </TableCell>
                  <TableCell className={classes.tablecell}>
                    {userType == 2 && selectedUser.email == undefined
                      ? ''
                      : `${userTaxInfo.yel_percentage} % `}
                  </TableCell>
                </TableRow>
                <TableRow style={{ background: '#ebf9fa' }}>
                  <TableCell className={classes.tablecell}>
                    {t('dashboarInfo.raha')}
                  </TableCell>
                  <TableCell className={classes.tablecell}>
                    {userType == 2 && selectedUser.email == undefined
                      ? ''
                      : new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(userTaxInfo.sumwitouttax)}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </div>
        </div>
      )
    }}
  </Translation>
)
OwnInfoComponent.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(OwnInfoComponent)
